module.exports = __webpack_public_path__ + "static/assets/7a3d188d587d856da4a6914fcfe82f65.png";